import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../services/api";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async () => {
    if (!password) {
      alert("Enter new password");
      return;
    }

    try {
      setLoading(true);

      await API.post("/auth/reset-password", {
        token,
        new_password: password,
      });

      alert("✅ Password reset successful");

      navigate("/login");
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.detail || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: "auto", padding: 20 }}>
      <h2>🔐 Reset Password</h2>

      <input
        type="password"
        placeholder="New password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={inputStyle}
      />

      <button onClick={handleReset} style={btn}>
        {loading ? "Resetting..." : "Reset Password"}
      </button>
    </div>
  );
};

const inputStyle = {
  width: "100%",
  padding: 12,
  marginTop: 20,
  borderRadius: 8,
  border: "1px solid #ddd",
};

const btn = {
  width: "100%",
  padding: 12,
  marginTop: 20,
  background: "#111",
  color: "#fff",
  border: "none",
  borderRadius: 8,
};

export default ResetPassword;